<template>
    <rkm-overlay>
        <rkm-layout-body title="Exportação">
            <rkm-layout-content>
                <div>
                    <strong style="font-size: 17px;">A versão do integrador atual é a {{ versaoIntegrador || 'Carregando...' }} compativel com a versão do ESUS {{ versaoCentralizador || 'Carregando...' }} ou superior</strong>
                </div>

                <Form
                    @versao-integrador-centralizador="handleVersaoIntegradorAndCentralizador"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from "@/components/atencao-basica/exportacao/Form";

export default {
    components: { Form },
    data: () => ({
        versaoIntegrador: null,
        versaoCentralizador: null
    }),
    methods: {
        handleVersaoIntegradorAndCentralizador(versao){
            this.versaoIntegrador = `${versao.integradorMajor}.${versao.integradorMinor}.${versao.integradorRevision}`
            this.versaoCentralizador = `${versao.centralizadorMajor}.${versao.centralizadorMinor}.${versao.centralizadorRevision}`
        },
    },
}
</script>